// Central config so the API + asset hosts live in one place.
export const API_URL =
  'https://4389hu9h61.execute-api.us-east-1.amazonaws.com/production';

// Cover art is served from the original VitaGamesDB host.
export const IMAGE_BASE = 'https://vitagamesdb.com/images';
export const FALLBACK_IMAGE = `${IMAGE_BASE}/undefined.jpg`;

export const imageUrl = (image: string): string =>
  image ? `${IMAGE_BASE}/${image}` : FALLBACK_IMAGE;
